import Vue from "vue";
import Vuex from "vuex";

// import axios from "axios";
// import AppConfig from "../../../AppConfig";
// import NODE_ENV from "../../../env";

// const baseURL = AppConfig[NODE_ENV]["apiGatewayBookings"];

Vue.use(Vuex);

export default {
  state: {
    showActiveTerminal: false,
    quoteShippingMethod: "terminal-to-terminal",
    quoteStore: {},
    reloadBokingData: null,
    lastCompletedFormNo: null,
    completedNewBookingTabNum: 1,
    takeOffLocationId: "",
    deliveryLocationId: "",
    currentShipping: {},
    paymentId: "",
    packageId: "",
    shippingId: "",
    packages: [],
    senderDropDate: "",
    processReturnDetails: {},
    bookingChangesindicator: false,
    ratingsBooking: {},
    thirdPLShippingMethosStart: "",
    thirdPLShippingMethosEnd: "",
    bookingPaymentType: "",
    bookingPaymentType3Pl: "",
    savedQuote3PL: {},
    newBooking: {
      prevShipper: {},
      shipper: {},
      consignee: {},
      newPackage: {},
      costEngine: {},
      packages: [],
      packageType: "",
      shippingInformation: {},
      shippingService: {},
      paymentInformation: {
        serviceCost: "",
        serviceType: "",
      },
      userPaymentSettings: {},
      routeType: "",
      dropOff: "",
      pickupDays: "",
      shippingMethod: "",
      consigneeShipmentType: "",
      shipperShipmentType: "",
      vehicleType: "",
    },
    latestNewBooking: {
      prevShipper: {},
      shippingMethod: ["", ""],
      shippingForSelf: null,
      shipper: {},
      consignee: {},
      newPackage: {},
      costEngine: {},
      packages: [],
      packageType: "",
      bookingStates: {},
      shippingInformation: {},
      initialShipping: {},
      transactionId: null,
      dropOffDays: undefined,
      hasSentTrips: false,
      paymentInformation: {
        serviceCost: "",
        serviceType: "",
      },
      userPaymentSettings: {},
    },
    paymentInformations: [],
    isNewConsignee: false,
    shiperLocationPreselected: false,
    consigneeLocationPreselected: false,
    takeOffTerminals: [],
    pickUpTerminals: [],
    costTypes: [],
    costType: "",
    shippingService: {},
    tripService: {},
    quoteResponse: {},
    orgLocations: [],
    managedLocations: [],
    currentLocationId: "",
    bookingRouteType: "",
  },
  getters: {
    getSavedQuote3Pl: (state) => {
      return state.savedQuote3PL;
    },
    getBookingpaymenttype3Pl: (state) => {
      return state.bookingPaymentType3Pl;
    },
    getBookingpaymenttype: (state) => {
      return state.bookingPaymentType;
    },
    getRatingsBooking: (state) => {
      return state.ratingsBooking;
    },
    getSenderDropDate: (state) => {
      return state.senderDropDate;
    },
    getBookingHasCreatedTrips: (state) => {
      return state.latestNewBooking.hasSentTrips;
    },
    getBookingStates: (state) => {
      return state.latestNewBooking.bookingStates;
    },
    getBookingShippingMethod: (state) => {
      return state.latestNewBooking.shippingMethod;
    },
    getBookingChangesindicator: (state) => {
      return state.bookingChangesindicator;
    },
    getQuoteShippingMethod: (state) => {
      return state.quoteShippingMethod;
    },
    getBookingTableData: (state) => {
      return state.setBookingDataTable;
    },
    latestProcessReturnDetails: (state) => {
      return state.processReturnDetails;
    },
    newQuoteStore: (state) => {
      return state.quoteStore;
    },
    newCurrentShipping: (state) => {
      return state.currentShipping;
    },
    latestNewPrevShipper: (state) => {
      return state.latestNewBooking.prevShipper;
    },
    latestNewBookingPackages: (state) => {
      return state.latestNewBooking.packages;
    },
    latestNewCostEngine: (state) => {
      return state.latestNewBooking.costEngine;
    },
    latestNewShippingForSelf: (state) => {
      return state.latestNewBooking.shippingForSelf;
    },
    latestNewInitialShipping: (state) => {
      return state.latestNewBooking.initialShipping;
    },
    latestNewTransactionId: (state) => {
      return state.latestNewBooking.transactionId;
    },
    latestNewShippingService: (state) => {
      return state.latestNewBooking.shippingService;
    },
    latestNewShippingInfo: (state) => {
      return state.latestNewBooking.shipperInformation;
    },
    latestNewBookingTab: (state) => {
      return state.completedNewBookingTabNum;
    },
    latestNewShipperId: (state) => {
      return state.latestNewBooking.shipper?.id;
    },
    latestNewConsigneeId: (state) => {
      return state.latestNewBooking.consignee?.id;
    },
    latestNewBooking: (state) => {
      return state.latestNewBooking;
    },
    quoteResponse: (state) => {
      return state.quoteResponse;
    },
    packageType: (state) => {
      return state.newBooking.packageType;
    },
    shipperInformation: (state) => {
      return state.newBooking.shipper;
    },
    consigneeInformation: (state) => {
      return state.newBooking.consignee;
    },
    userPaymentSettings: (state) => {
      return state.newBooking.userPaymentSettings;
    },
    packageInformation: (state) => {
      return state.newBooking.newPackage;
    },
    shippingInformation: (state) => {
      return state.newBooking.shippingInformation;
    },
    paymentInformation: (state) => {
      return state.newBooking.paymentInformation;
    },
    lastCompletedFormNo: (state) => {
      return state.lastCompletedFormNo;
    },
    takeOffLocationId: (state) => {
      return state.takeOffLocationId;
    },
    deliveryLocationId: (state) => {
      return state.deliveryLocationId;
    },
    pickupAddress: (state) => {
      return state.newBooking.shipper.location;
    },
    deliveryAddress: (state) => {
      return state.newBooking.consignee.location;
    },
    packageId: (state) => {
      return state.packageId;
    },
    paymentId: (state) => {
      return state.paymentId;
    },
    transactionId: (state) => {
      return state.transactionId;
    },
    shippingId: (state) => {
      return state.shippingId;
    },
    packageIds: (state) => {
      return state.packageIds;
    },
    paymentInformations: (state) => {
      return state.paymentInformations;
    },
    packages: (state) => {
      return state.packages;
    },
    isNewConsignee: (state) => {
      return state.isNewConsignee;
    },
    shipperLocationPreselected: (state) => {
      return state.shiperLocationPreselected;
    },
    consigneeLocationPreselected: (state) => {
      return state.consigneeLocationPreselected;
    },
    takeOffTerminals: (state) => {
      return state.takeOffTerminals;
    },
    pickUpTerminals: (state) => {
      return state.pickUpTerminals;
    },
    costTypes: (state) => {
      return state.costTypes;
    },
    costType: (state) => {
      return state.costType;
    },
    shippingService: (state) => {
      return state.shippingService;
    },
    managedLocations: (state) => {
      return state.managedLocations;
    },
    currentLocationId: (state) => {
      return state.currentLocationId;
    },
    currentLocation: (state) => {
      return state.managedLocations.find(
        (x) => x.locationId == state.currentLocationId
      );
    },
    orgLocations: (state) => {
      return state.orgLocations;
    },
    routeType: (state) => {
      return state.newBooking.routeType;
    },
    getShowTermninal: (state) => {
      return state.showActiveTerminal;
    },
  },
  mutations: {
    RESET_STATE: (state) => {
      const initialState = {
        lastCompletedFormNo: null,
        takeOffLocationId: "",
        deliveryLocationId: "",
        paymentId: "",
        packageId: "",
        packageIds: [],
        transactionId: "",
        packages: [],
        tripService: {},
        newBooking: {
          shipper: {},
          consignee: {},
          newPackage: {},
          shippingInformation: {},
          paymentInformation: {
            serviceCost: "",
            serviceType: "",
          },
        },
      };
      Object.assign(state, initialState);
    },
    RESET_NEW_BOOKING_STATE(state) {
      state.latestNewBooking = {
        shippingMethod: ["", ""],
        shippingForSelf: null,
        shipper: {},
        prevShipper: {},
        consignee: {},
        newPackage: {},
        costEngine: {},
        packages: [],
        packageType: "",
        bookingStates: {},
        shippingInformation: {},
        initialShipping: {},
        transactionId: null,
        hasSentTrips: false,
        paymentInformation: {
          serviceCost: "",
          serviceType: "",
        },
      };
      state.completedNewBookingTabNum = 1;
      state.senderDropDate = "";
      state.quoteStore = {};
      state.bookingPaymentType3Pl = "";
      (state.currentShipping = {}),
        (state.quoteResponse = "drop-off"),
        (state.bookingChangesindicator = false);
    },
    LIGHT_RESET_NEW_BOOKING_STATE(state) {
      state.latestNewBooking.newPackage = {}
      state.completedNewBookingTabNum = 1;
      state.latestNewBooking.packages = []
      state.latestNewBooking.consignee = {}
      state.latestNewBooking.prevShipper = {}
      state.latestNewBooking.shipper = {}
      state.latestNewBooking.shipperInformation = {}
      state.latestNewBooking.initialShipping = {}
    },
    SET_SAVED_QUOTE_3PL(state, Payload) {
      state.savedQuote3PL = Payload;
    },
    SET_BOOKING_PL_PAYMENT_TYPE(state, Payload) {
      state.bookingPaymentType3Pl = Payload;
    },
    SET_BOOKING_PAYMENT_TYPE(state, Payload) {
      state.bookingPaymentType = Payload;
    },
    SET_TRIP_SERVICE(state, Payload) {
      state.tripService = Payload;
    },
    SET_3PL_SHIPPINGMETHOD_END(state, Payload) {
      state.thirdPLShippingMethosEnd = Payload;
    },
    SET_3PL_SHIPPINGMETHOD_START(state, Payload) {
      state.thirdPLShippingMethosStart = Payload;
    },
    SET_RATINGS_BOOKING(state, Payload) {
      state.ratingsBooking = Payload;
    },
    SET_BOOKING_SENDER_DROP_DATE(state, Payload) {
      state.senderDropDate = Payload;
    },
    SET_BOOKING_HAS_SET_TRIPS(state, Payload) {
      state.latestNewBooking.hasSentTrips = Payload;
    },
    SET_BOOKING_STATES(state, Payload) {
      state.latestNewBooking.bookingStates = Payload;
    },
    SET_BOOKING_DROP_OFF_DAYS(state, Payload) {
      state.latestNewBooking.dropOffDays = Payload;
    },
    SET_NEW_BOOKING_SHIPPING_METHOD_START(state, Payload) {
      state.latestNewBooking.shippingMethod[0] = Payload;
    },
    SET_NEW_BOOKING_SHIPPING_METHOD_END(state, Payload) {
      state.latestNewBooking.shippingMethod[1] = Payload;
    },
    SET_BOOKING_CHANGES_INDICATOR(state, Payload) {
      state.setBookingDataTable = Payload;
    },
    SET_TABLE_BOOKING_DATA(state, Payload) {
      state.setBookingDataTable = Payload;
    },
    SET_QUOTE_SHIPPING_METHOD(state, Payload) {
      state.quoteShippingMethod = Payload;
    },
    SAVE_PROCESS_RETURN_DETAILS(state, Payload) {
      state.processReturnDetails = Payload;
    },
    SAVE_AUTOLOAD_BOOKING_PROPERTY(state, Payload) {
      state.latestNewBooking = { ...state.latestNewBooking, ...Payload };
    },
    SAVE_NEW_CURRENT_SHIPPING(state, Payload) {
      state.currentShipping = Payload;
    },
    SAVE_NEW_QUOTE_STORE(state, Payload) {
      state.quoteStore = Payload;
    },
    SAVE_NEW_LATEST_PREV_SHIPPER(state, Payload) {
      state.latestNewBooking.prevShipper = Payload;
    },
    SAVE_NEW_LATEST_COST_ENGINE(state, Payload) {
      state.latestNewBooking.costEngine = Payload;
      console.log("mutation", Payload, state.latestNewBooking.costEngine);
    },
    SAVE_NEW_INITIAL_SHIPPING(state, Payload) {
      state.latestNewBooking.initialShipping = Payload;
    },
    SAVE_NEW_SHIPPING_FOR_SELF(state, Payload) {
      state.latestNewBooking.shippingForSelf = Payload;
    },
    SAVE_NEW_TRANSACTION_ID(state, Payload) {
      state.latestNewBooking.transactionId = Payload;
    },
    SAVE_NEW_SHIPPING_SERVICE(state, Payload) {
      state.latestNewBooking.shippingService = Payload;
    },
    SAVE_NEW_SHIPPING_INFO(state, Payload) {
      state.latestNewBooking.shipperInformation = Payload;
    },
    SAVE_NEW_BOOKING_PACKAGE(state, Payload) {
      state.latestNewBooking.packages = Payload;
    },
    SAVE_NEW_BOOKING_TAB(state, Payload) {
      state.completedNewBookingTabNum = Payload;
    },
    SAVE_NEW_BOOKING_SHIPPER(state, shipper) {
      state.latestNewBooking.shipper = shipper;
    },
    SAVE_NEW_BOOKING_CONSIGNEE(state, consignee) {
      state.latestNewBooking.consignee = consignee;
    },
    SAVE_TAKEOFF_TERMINALS(state, terminals) {
      state.takeOffTerminals = terminals;
    },
    SAVE_PICKUP_TERMINALS(state, terminals) {
      state.pickUpTerminals = terminals;
    },
    SAVE_BOOKING_INFORMATION(state, { property, value }) {
      state.newBooking[property] = value;
    },
    SAVE_LAST_COMPLETED_FORM(state, payload) {
      state.lastCompletedFormNo = payload;
    },
    SAVE_TAKEOFF_LOCATION_ID(state, payload) {
      state.takeOffLocationId = payload;
    },
    SAVE_DELIVERY_LOCATION_ID(state, payload) {
      state.deliveryLocationId = payload;
    },
    SAVE_PACKAGE_ID(state, payload) {
      state.packageId = payload;
    },
    SAVE_PAYMENT_INFORMATION(state, payload) {
      state.newBooking.paymentInformation = payload;
    },
    SAVE_PAYMENT_ID(state, payload) {
      state.paymentId = payload;
    },
    SAVE_TRANSACTION_ID(state, payload) {
      state.transactionId = payload;
    },
    SAVE_SHIPPING_ID(state, payload) {
      state.shippingId = payload;
    },
    SAVE_PACKAGE_IDS(state, payload) {
      state.packageIds = payload;
    },
    SAVE_SINGLE_PAYMENT_INFORMATION(state, payload) {
      state.paymentInformations.push(payload);
    },
    SAVE_PACKAGES(state, payload) {
      state.packages = payload;
    },
    SAVE_COST_TYPES(state, payload) {
      state.costTypes = payload;
    },
    SAVE_QUOTE_RESPONSE(state, payload) {
      state.quoteResponse = payload;
    },
    SAVE_COST_TYPE(state, payload) {
      state.costType = payload;
    },
    SAVE_SHIPPING_SERVICE(state, payload) {
      state.shippingService = payload;
    },
    SAVE_SELECTED_SHIPPER_LOCATION(state, payload) {
      state.shiperLocationPreselected = true;
      state.newBooking.shipper = { ...payload };
    },
    SAVE_SELECTED_CONSIGNEE_LOCATION(state, payload) {
      state.consigneeLocationPreselected = true;
      state.newBooking.consignee = { ...payload };
    },
    SET_SHIPPING_ROUTE_TYPE(state, payload) {
      state.bookingRouteType = payload;
      state.newBooking.routeType = payload;
    },
    SAVE_MANAGED_LOCATIONS(state, payload) {
      state.managedLocations = payload;
    },
    SAVE_ORG_LOCATIONS(state, payload) {
      state.orgLocations = payload;
    },
    SET_CURRENT_LOCATION_ID(state, payload) {
      state.currentLocationId = payload;
    },
    SET_SHOW_TERMINAL(state, payload) {
      state.showActiveTerminal = payload;
    },
    REMOVE_OLD_CONSIGNEE_DATA(state) {
      state.isNewConsignee = true;
      state.newBooking.consignee = {
        email: "",
        mobile: "",
        address: "",
        customerType: "business",
        userId: "",
        city: "",
        state: "",
        country: "",
        zipCode: "",
        contactName: "",
      };
      state.newBooking.newPackage = {
        type: "",
        quantity: "",
        length: "",
        width: "",
        height: "",
        weight: "",
        packagingType: "",
        description: "",
        value: "",
        specialHandling: "",
      };
      state.newBooking.shippingInformation = {
        takeOffLocationId: "",
        deliveryLocationId: "",
        shippingMethod: "",
        tripMode: "",
        shippingServiceId: "",
        sourcePickupTime: "",
        destinationPickupTime: "",
        portOrigin: "",
        portDestination: "",
        payOnDelivery: false,
        deliveryConfirmation: false,
        paymentStatus: "not paid",
        stops: [],
      };
    },
  },

  actions: {
    setShoTerminal({ commit }, payload) {
      commit("SET_SHOW_TERMINAL", payload);
    },
    setSavedQuote3pl({ commit }, payload) {
      commit("SET_SAVED_QUOTE_3PL", payload);
    },
    setBookingPaymenttype3pl({ commit }, payload) {
      commit("SET_BOOKING_PL_PAYMENT_TYPE", payload);
    },
    setBookingPaymentType({ commit }, payload) {
      commit("SET_BOOKING_PAYMENT_TYPE", payload);
    },
    setTripService({ commit }, payload) {
      commit("SET_TRIP_SERVICE", payload);
    },
    set3PLShippingMethodEnd({ commit }, payload) {
      commit("SET_3PL_SHIPPINGMETHOD_END", payload);
    },
    set3PLShippingMethodStart({ commit }, payload) {
      commit("SET_3PL_SHIPPINGMETHOD_START", payload);
    },
    setRatingsBooking({ commit }, payload) {
      commit("SET_RATINGS_BOOKING", payload);
    },
    setBookingSenderDropDate({ commit }, payload) {
      commit("SET_BOOKING_SENDER_DROP_DATE", payload);
    },
    setBookingHasCreatedTrips({ commit }, payload) {
      commit("SET_BOOKING_HAS_SET_TRIPS", payload);
    },
    setBookingDropOffDays({ commit }, payload) {
      commit("SET_BOOKING_DROP_OFF_DAYS", payload);
    },
    saveBookingStates({ commit }, payload) {
      commit("SET_BOOKING_STATES", payload);
    },
    saveBookingMethodStart({ commit }, payload) {
      commit("SET_NEW_BOOKING_SHIPPING_METHOD_START", payload);
    },
    saveBookingMethodEnd({ commit }, payload) {
      commit("SET_NEW_BOOKING_SHIPPING_METHOD_END", payload);
    },
    saveBookingChangesIndicator({ commit }, payload) {
      commit("SET_BOOKING_CHANGES_INDICATOR", payload);
    },
    actionQuoteShippingResponse({ commit }, payload) {
      commit("SET_QUOTE_SHIPPING_METHOD", payload);
    },
    actionBookingDataTable({ commit }, payload) {
      commit("SET_TABLE_BOOKING_DATA", payload);
    },
    saveProcessReturnDetails({ commit }, payload) {
      commit("SAVE_PROCESS_RETURN_DETAILS", payload);
    },
    saveNewCurrentShipping({ commit }, payload) {
      commit("SAVE_NEW_CURRENT_SHIPPING", payload);
    },
    saveQuoteStore({ commit }, payload) {
      commit("SAVE_NEW_QUOTE_STORE", payload);
    },
    saveLatestInitialBookingData({ commit }, payload) {
      commit("SAVE_AUTOLOAD_BOOKING_PROPERTY", payload);
    },
    saveLatestPrevShipper({ commit }, payload) {
      commit("SAVE_NEW_LATEST_PREV_SHIPPER", payload);
    },
    saveLatestNewCostEngine({ commit }, payload) {
      commit("SAVE_NEW_LATEST_COST_ENGINE", payload);
    },
    saveLatestNewShippingForSelf({ commit }, payload) {
      commit("SAVE_NEW_SHIPPING_FOR_SELF", payload);
    },
    saveResetNewBookingState({ commit }) {
      commit("RESET_NEW_BOOKING_STATE");
    },
    lightResetNewBookingState({ commit }) {
      commit("LIGHT_RESET_NEW_BOOKING_STATE");
    },
    saveLatestNewInitialShipping({ commit }, payload) {
      commit("SAVE_NEW_INITIAL_SHIPPING", payload);
    },
    saveLatestNewTransactionId({ commit }, payload) {
      commit("SAVE_NEW_TRANSACTION_ID", payload);
    },
    saveLatestNewShippingService({ commit }, payload) {
      commit("SAVE_NEW_SHIPPING_SERVICE", payload);
    },
    saveLatestNewShippingInfo({ commit }, payload) {
      commit("SAVE_NEW_SHIPPING_INFO", payload);
    },
    saveLatestNewBookinTabNum({ commit }, payload) {
      commit("SAVE_NEW_BOOKING_TAB", payload);
    },
    saveLatestNewBookinPackages({ commit }, payload) {
      commit("SAVE_NEW_BOOKING_PACKAGE", payload);
    },
    saveLatestNewBookingShipper({ commit }, payload) {
      commit("SAVE_NEW_BOOKING_SHIPPER", payload);
    },
    saveLatestNewBookingConsignee({ commit }, payload) {
      commit("SAVE_NEW_BOOKING_CONSIGNEE", payload);
    },
    saveTakeOffTerminals({ commit }, payload) {
      commit("SAVE_TAKEOFF_TERMINALS", payload);
    },
    saveQuoteResponse({ commit }, payload) {
      commit("SAVE_QUOTE_RESPONSE", payload);
    },
    savePickUpTerminals({ commit }, payload) {
      commit("SAVE_PICKUP_TERMINALS", payload);
    },
    saveBookingInformation({ commit }, { property, value }) {
      commit("SAVE_BOOKING_INFORMATION", { property, value });
    },
    saveLastCompletedFormNo({ commit }, payload) {
      // console.log(payload);
      commit("SAVE_LAST_COMPLETED_FORM", payload);
    },
    saveTakeOffLocationId({ commit }, payload) {
      commit("SAVE_TAKEOFF_LOCATION_ID", payload);
    },
    saveCostTypes({ commit }, payload) {
      commit("SAVE_COST_TYPES", payload);
    },
    saveCostType({ commit }, payload) {
      commit("SAVE_COST_TYPE", payload);
    },
    saveShippingService({ commit }, payload) {
      commit("SAVE_SHIPPING_SERVICE", payload);
    },
    saveDeliveryLocationId({ commit }, payload) {
      commit("SAVE_DELIVERY_LOCATION_ID", payload);
    },
    savePackageId({ commit }, payload) {
      commit("SAVE_PACKAGE_ID", payload);
    },
    savePaymentInformation({ commit }, payload) {
      commit("SAVE_PAYMENT_INFORMATION", payload);
    },
    savePaymentId({ commit }, payload) {
      commit("SAVE_PAYMENT_ID", payload);
    },
    saveTransactionId({ commit }, payload) {
      commit("SAVE_TRANSACTION_ID", payload);
    },
    saveShippingId({ commit }, payload) {
      commit("SAVE_SHIPPING_ID", payload);
    },
    resetState({ commit }) {
      commit("RESET_STATE");
    },
    removeOldConsigneeData({ commit }) {
      commit("REMOVE_OLD_CONSIGNEE_DATA");
    },
    savePackageIds({ commit }, payload) {
      commit("SAVE_PACKAGE_IDS", payload);
    },
    saveSinglePaymentInformation({ commit }, payload) {
      commit("SAVE_SINGLE_PAYMENT_INFORMATION", payload);
    },
    savePackages({ commit }, payload) {
      commit("SAVE_PACKAGES", payload);
    },
    saveSelectedShipperLocation({ commit }, payload) {
      commit("SAVE_SELECTED_SHIPPER_LOCATION", payload);
    },
    saveSelectedConsigneeLocation({ commit }, payload) {
      commit("SAVE_SELECTED_CONSIGNEE_LOCATION", payload);
    },
    saveManagedLocations({ commit }, payload) {
      commit("SAVE_MANAGED_LOCATIONS", payload);
    },
    saveOrgLocations({ commit }, payload) {
      commit("SAVE_ORG_LOCATIONS", payload);
    },
    setCurrentLocationId({ commit }, payload) {
      commit("SET_CURRENT_LOCATION_ID", payload);
    },
    saveShippingRouteType({ commit }, payload) {
      commit("SET_SHIPPING_ROUTE_TYPE", payload);
    },
  },
};
